module.exports = __webpack_public_path__ + "img/tc3.b98fd6b8.png";